import * as navigator from "client_legacy/ndaw/navigator";
import * as antiForgery from "./antiForgery";
import { HttpClient } from "client/Api/httpClient";

let _readyPromise: Promise<void> | null;

export function ready(init: () => void): void {
	if (!_readyPromise) {
		let resolve: () => void;

		_readyPromise = new Promise<void>(
			(res) => { resolve = res; }
		);

		const { readyState } = document;
		if (readyState === "complete" || readyState === "interactive") {
			setTimeout(
				() => resolve(),
				0
			);
		} else {
			document.addEventListener(
				"DOMContentLoaded",
				() => resolve(),
				{ once: true }
			);
		}
	}

	_readyPromise
		.then(init);
}

export function initialize(): void {
	HttpClient.registerResponseHandler(
		401,
		(): void => navigator.reloadCurrentPage()
	);

	HttpClient.registerBeforeRequestHandler(
		(request): void => {
			if (request.url.origin !== window.origin) {
				// Only include AntiForgery to our current origin
				return;
			}

			switch(request.method.toUpperCase()) {
				case "POST":
				case "PUT":
				case "PATCH":
				case "DELETE":
					const securityToken: string | undefined = antiForgery.getToken();
					if (securityToken) { // handle only when token is available
						const requestHeaderName: string = antiForgery.getHeaderName();
						request.headers
							.set(requestHeaderName, securityToken);
					}
					break;
				default:
					// No AntiForgery needed for these methods
					break;
			}
		}
	);
}
